import React from 'react';

import { formatInteractiveSelectionReply, getInteractiveMessageSummary } from '../../conversations/utils/messageUtils';
import { Message } from '../../conversations/types/Conversation';
import { isVisitorWebWidgetMessage } from '../utils/webWidgetMessageAlignment';

import styles from './EmbeddedWebWidget.module.css';

interface WebWidgetInteractiveMessageProps {
  message: Message;
  disabled?: boolean;
  onSelect: (replyText: string) => void | Promise<void>;
}

export const WebWidgetInteractiveMessage: React.FC<WebWidgetInteractiveMessageProps> = ({
  message,
  disabled = false,
  onSelect,
}) => {
  const summary = getInteractiveMessageSummary(message);
  const isCustomerMessage = isVisitorWebWidgetMessage(message);
  const canSelect = !disabled && !isCustomerMessage;

  return (
    <div className={styles.interactiveCard}>
      {summary?.bodyText ? (
        <strong className={styles.interactiveBody}>{summary.bodyText}</strong>
      ) : message.content ? (
        <div className={styles.content}>{message.content}</div>
      ) : null}

      {message.interactiveList?.sections?.length ? (
        <div className={styles.interactiveSectionsList}>
          {message.interactiveList.sections.map((section, sectionIndex) => (
            <div key={`webchat-interactive-section-${sectionIndex}`} className={styles.interactiveSectionCard}>
              {section.title ? <span className={styles.interactiveSectionTitle}>{section.title}</span> : null}
              {section.rows.map(row => (
                canSelect ? (
                  <button
                    key={row.id}
                    type="button"
                    className={`${styles.interactiveRowCard} ${styles.interactiveRowAction}`}
                    onClick={() => void onSelect(formatInteractiveSelectionReply(row))}
                    disabled={disabled}
                  >
                    <strong>{row.title}</strong>
                    {row.description ? <span>{row.description}</span> : null}
                  </button>
                ) : (
                  <div key={row.id} className={styles.interactiveRowCard}>
                    <strong>{row.title}</strong>
                    {row.description ? <span>{row.description}</span> : null}
                  </div>
                )
              ))}
            </div>
          ))}
        </div>
      ) : message.interactiveButtons?.buttons?.length ? (
        <div className={styles.interactiveSectionsList}>
          <div className={styles.interactiveSectionCard}>
            {message.interactiveButtons.buttons.map(button => (
              canSelect ? (
                <button
                  key={button.id}
                  type="button"
                  className={`${styles.interactiveRowCard} ${styles.interactiveRowAction}`}
                  onClick={() => void onSelect(button.title)}
                  disabled={disabled}
                >
                  <strong>{button.title}</strong>
                </button>
              ) : (
                <div key={button.id} className={styles.interactiveRowCard}>
                  <strong>{button.title}</strong>
                </div>
              )
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};
